import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import {useEffect} from "react";
import ApiService from "../../../core/service/api-service";
import DataGrid from "../../../core/components/data-grid/DataGrid";
import deviceColumns from "./DeviceColumns";
import {useTranslation} from "react-i18next";

export default function DeviceGrid()
{
    const {t} = useTranslation();
    const {setData, setPaginationResult, queryModel, setDataGridProps} = useDataGrid();

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            columns: deviceColumns(t),
        })
    }, [])

    const getDeviceGrid = async () => {
        const response = await ApiService.Device.GetDataGrid(queryModel);
        if(response.success)
        {
            setData(response.data);
            setPaginationResult(response.pagination)
        }
    }

    useEffect(() => {
        getDeviceGrid()
    }, [queryModel.updateKey])

    return (
        <>
            <DataGrid name={'device'}/>
        </>
    )
}
